import { render } from "./BookingSlotList.vue?vue&type=template&id=41093377"
import script from "./BookingSlotList.vue?vue&type=script&lang=js"
export * from "./BookingSlotList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__